<ng-container *ngIf="!ready">
  <div class="cf-dlg-loading">
    <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
    <p class="cf-dlg-loading__text">Cargando...</p>
  </div>
</ng-container>

<ng-container *ngIf="ready">

<div class="dlg-hdr">
  <div class="dlg-hdr__title">
    <div class="dlg-hdr__icon-wrap"><mat-icon>account_balance</mat-icon></div>
    <div>
      <span>Cuenta bancaria</span>
      <small class="dlg-hdr__sub" *ngIf="flagImport">Importación: {{movement.reference}}</small>
    </div>
  </div>
  <button mat-icon-button class="dlg-hdr__close" (click)="closeDialog()" aria-label="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="dlg-body">

  <mat-form-field class="w-100" appearance="outline">
    <mat-label>Código BIC/Swift — Nombre del banco</mat-label>
    <input matInput [(ngModel)]="bankAccount.swift" size="120" [matAutocomplete]="auto"
      [formControl]="bicsCtrl" required>
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option *ngFor="let bic of filteredBics | async; trackBy: trackByIndex" [value]="bic.bic">
        {{ bic.bic }} — {{ bic.bank }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <app-input inputType="text" placeholder="Entidad" [isRequired]="true" [(ngModel)]="bankAccount.bank"></app-input>

  <mat-form-field class="w-100" appearance="outline">
    <mat-label>IBAN</mat-label>
    <input type="text" matInput ngxIban required [(ngModel)]="bankAccount.iban" maxlength=34>
  </mat-form-field>

  <div style="display:flex;align-items:center;gap:12px;margin-top:4px">
    <button mat-stroked-button (click)="showApiKey = !showApiKey">
      {{ showApiKey ? 'Ocultar UID' : 'Ver UID' }}
    </button>
    <span *ngIf="showApiKey" style="font-family:monospace;font-size:12px;color:#6b7280">{{ bankAccount.uid }}</span>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end" class="dlg-actions">
  <button mat-stroked-button (click)="closeDialog()">Cancelar</button>
  <button mat-flat-button class="dlg-btn-save" (click)="save(bankAccount)">
    <mat-icon>save</mat-icon>
    Guardar
  </button>
</mat-dialog-actions>

</ng-container>
